// ── Microsoft Clarity (P4.1) ──────────────────────────────────────────────────
// Consent-gated loader: a Clarity script CSAK statisztikai süti-hozzájárulás
// UTÁN töltődik be (a CookieBanner enableAnalytics hívja), és csak productionben.
// A project ID env-ből jön (REACT_APP_CLARITY_ID) – nincs hardcode; ha nincs
// beállítva, a teljes integráció csendben inaktív.

const CLARITY_ID = process.env.REACT_APP_CLARITY_ID || '';
const prod = process.env.NODE_ENV === 'production';

let loaded = false;

/** Clarity betöltés + init – idempotens, consent után hívandó. */
export const initClarity = () => {
  if (loaded || !prod || !CLARITY_ID) return;
  loaded = true;
  try {
    // Hivatalos snippet, defer/async betöltéssel
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_ID);
    // Consent Mode jelzés a Clarity-nek (cookie-írás engedélyezett)
    window.clarity('consent');
  } catch (e) { /* analytics sosem törhet appot */ }
};

/** Egyedi üzleti esemény – no-op, amíg a Clarity nincs betöltve (nincs consent).
 *  A window.clarity stub queue-t használ, így az init utáni hívások biztosan
 *  célba érnek; consent előtt szándékosan NEM queue-olunk (GDPR). */
export const clarityEvent = (name) => {
  try {
    if (loaded && window.clarity) window.clarity('event', name);
  } catch (e) { /* no-op */ }
};
